/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Context_LabelInputs */

const en_us2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the trainer is taking into account`)
};

const pt_br2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o personal está levando em conta`)
};

const es_419_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que el entrenador está teniendo en cuenta`)
};

const pt_pt2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o treinador está a ter em conta`)
};

const fr_fr2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que le coach prend en compte`)
};

const de_de2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was der Coach berücksichtigt`)
};

const it_it2_coach_context_label = /** @type {(inputs: Coach_Context_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa sta considerando il coach`)
};

/**
* | output |
* | --- |
* | "What the trainer is taking into account" |
*
* @param {Coach_Context_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_label = /** @type {((inputs?: Coach_Context_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_label(inputs)
	if (locale === "es-419") return es_419_coach_context_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_label(inputs)
	if (locale === "de-DE") return de_de2_coach_context_label(inputs)
	if (locale === "it-IT") return it_it2_coach_context_label(inputs)
	return en_us2_coach_context_label(inputs)
});
export { coach_context_label as "coach.context_label" }